import { createContext, useState } from "react";

export const GastosContext = createContext();

export const GastosProvider = ({ children }) => {

    const [costs, setCosts] = useState([]); // Estado que armazena a lista de Gastos existentes
    const [isSaving, setIsSaving] = useState(false); // Estado que armazena se o usuário está salvando ou não

    return (
        <GastosContext.Provider value={{ costs, setCosts, isSaving, setIsSaving }}>
            {children}
        </GastosContext.Provider>
    );
};
